import {
  BodyDefaultTypography,
  BREAKPOINT,
  InterZellerMediumFont,
} from '@npco/zeller-design-system'
import styled from 'styled-components/macro'

export const StyledTransferRecipient = styled.div`
  margin: 1rem 1rem 1.5rem;
`

export const StyledTransferSummaryRow = styled.article`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin: 1rem 0;
  gap: 16px;
`

export const StyledTransferAmount = styled.p`
  margin: 0;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.BLACK_900};
  ${InterZellerMediumFont};
`

export const StyledTransferValue = styled.p`
  margin: 0;
  ${BodyDefaultTypography};
  text-align: justify;
  max-width: 350px;
  word-break: break-all;
`

export const StyledTransferDetails = styled.div`
  padding: 16px 0 32px;
  margin: 0;

  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    padding: 16px 0 56px;
  }
`

export const StyledAccountElement = styled.section`
  display: flex;
  align-items: stretch;
  width: 100%;
  position: relative;
  background: transparent;
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.colors.WHITE};
  transition: all 0.4s ease-out;
`

export const StyledExternalDetailsList = styled.div`
  display: flex;
  align-items: center;

  > * {
    padding-right: 0.25rem;
    margin-right: 0.25rem;
    position: relative;

    &:after {
      content: '';
      width: 2px;
      height: 2px;
      background-color: ${({ theme }) => theme.colors.GREY_250};
      border-radius: 50%;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%) translateX(50%);
    }

    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`
export const StyledExternalDetails = styled.span`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.GREY_550};
  white-space: nowrap;
`
